import { EAutoType } from "../Enum/EAutoType"
import { ECustomerPaymentType } from "../Enum/ECustomerPaymentType"
import { EEnableStatusType } from "../Enum/EEnableStatusType"
import { EGenderType } from "../Enum/EGenderType"
import { ELanguagens } from "../Enum/ELanguagens"
import { EMoneyConditionType } from "../Enum/EMoneyConditionType"
import { EOldType } from "../Enum/EOldType"
import { EOrderCurrentStatus } from "../Enum/EOrderCurrentStatus"
import { EOrdenationType } from "../Enum/EOrdenationType"
import { ESexType } from "../Enum/ESexType"
import { ETypeOfCharge } from "../Enum/ETypeOfCharge"
import { EPaymentType } from "../Enum/EPaymentType"
import { EOrderPlaceType } from "../Enum/EOrderPlaceType"
import { EOrderType } from "../Enum/EOrderType"
import { ECourierStatusType } from "../Enum/ECourierStatusType"
import { ECourierVehicleType } from "../Enum/ECourierVehicleType"
import { EDeliveryStatusType } from "../Enum/EDeliveryStatusType"
import { EAccountPlansType } from "../Enum/EAccountPlansType"
import { ERestaurantServiceType } from "../Enum/ERestaurantServiceType"
import { ECommercialOriginType } from "../Enum/ECommercialOriginType"
import { EAdminGrowthInvestmentCategoryType } from "../Enum/EAdminGrowthInvestmentCategoryType"
import { EBillingPeriodType } from "../Enum/EBillingPeriodType"
import { EPlanCouponDiscountType } from "../Enum/EPlanCouponDiscountType"
import { EOrderPaymentProviderType } from "../Enum/EOrderPaymentProviderType"
import i18next from "i18next"

export {}

declare global {
  interface Number {
    toGenderTypeString(): string
    toEnableStatusTypeString(): string
    toMoneyConditionTypeString(): string
    toAutoTypeString(): string
    toTypeOfChangeString(): string
    toSexTypeString(): string
    toCustomerPaymentTypeString(): string
    toOldTypeString(): string
    toOrderType(): string
    toPaymentTypeString(): string
    toEOrderTypeString(): string
    toLanguageType(): LanguageOption
    toOrderCurrentStatusString(): string
    toOrderPlaceTypeString(): string
    toCourierStatusTypeString(): string
    toCourierVehicleTypeString(): string
    toDeliveryStatusTypeString(): string
    toEAccountPlansTypeToString(): string
    toEBillingPeriodTypeToString(): string
    toEPlanCouponDiscountTypeToString(): string
    toERestaurantServiceTypeString(): string
    toECommercialOriginTypeString(): string
    toEAdminGrowthInvestmentCategoryTypeString(): string
    toOrderPaymentProviderTypeString(): string
  }

  interface ObjectConstructor {
    mapEnumToStrings<T extends Record<string, number | string>>(
      enumType: T,
      options?: {
        exclude?: number[]
      },
    ): any[]
  }
}

if (!Object.mapEnumToStrings) {
  Object.mapEnumToStrings = function <T extends Record<string, number | string>>(
    enumType: T,
    options?: { exclude?: number[] },
  ): any[] {
    let values = Object.values(enumType).filter((e) => typeof e === "number") as number[]

    if (options?.exclude?.length) {
      values = values.filter((v) => !options.exclude!.includes(v))
    }

    if (Object.is(enumType, EEnableStatusType as any)) {
      return values.map((e) => e.toEnableStatusTypeString())
    }

    if (Object.is(enumType, EOrderType as any)) {
      return values.map((e) => e.toEOrderTypeString())
    }

    if (Object.is(enumType, ECourierStatusType as any)) {
      return values.map((e) => e.toCourierStatusTypeString())
    }

    if (Object.is(enumType, ECourierVehicleType as any)) {
      return values.map((e) => e.toCourierVehicleTypeString())
    }

    if (Object.is(enumType, EDeliveryStatusType as any)) {
      return values.map((e) => e.toDeliveryStatusTypeString())
    }

    if (Object.is(enumType, EAccountPlansType as any)) {
      return values.map((e) => e.toEAccountPlansTypeToString())
    }

    if (Object.is(enumType, EBillingPeriodType as any)) {
      return values.map((e) => e.toEBillingPeriodTypeToString())
    }

    if (Object.is(enumType, EPlanCouponDiscountType as any)) {
      return values.map((e) => e.toEPlanCouponDiscountTypeToString())
    }

    if (Object.is(enumType, ERestaurantServiceType as any)) {
      return values.map((e) => e.toERestaurantServiceTypeString())
    }

    if (Object.is(enumType, ESexType as any)) {
      return values.map((e) => e.toSexTypeString())
    }

    if (Object.is(enumType, EOrderPlaceType as any)) {
      return values.map((e) => e.toOrderPlaceTypeString())
    }

    if (Object.is(enumType, ELanguagens as any)) {
      return values.map((e) => e.toLanguageType())
    }

    if (Object.is(enumType, EOrdenationType as any)) {
      return values.map((e) => e.toOrderType())
    }

    if (Object.is(enumType, EOrderCurrentStatus as any)) {
      return values.map((e) => e.toOrderCurrentStatusString())
    }

    if (Object.is(enumType, EOldType as any)) {
      return values.map((e) => e.toOldTypeString())
    }

    if (Object.is(enumType, ECustomerPaymentType as any)) {
      return values.map((e) => e.toCustomerPaymentTypeString())
    }

    if (Object.is(enumType, EPaymentType as any)) {
      return values.map((e) => e.toPaymentTypeString())
    }

    if (Object.is(enumType, ECommercialOriginType as any)) {
      return values.map((e) => e.toECommercialOriginTypeString())
    }

    if (Object.is(enumType, EAdminGrowthInvestmentCategoryType as any)) {
      return values.map((e) => e.toEAdminGrowthInvestmentCategoryTypeString())
    }

    if (Object.is(enumType, EGenderType as any)) {
      return values.map((e) => e.toGenderTypeString())
    }

    if (Object.is(enumType, EMoneyConditionType as any)) {
      return values.map((e) => e.toMoneyConditionTypeString())
    }

    if (Object.is(enumType, EAutoType as any)) {
      return values.map((e) => e.toAutoTypeString())
    }

    if (Object.is(enumType, ETypeOfCharge as any)) {
      return values.map((e) => e.toTypeOfChangeString())
    }

    return values.map((e) => e.toString())
  }
}

if (!Number.prototype.toEAdminGrowthInvestmentCategoryTypeString) {
  Number.prototype.toEAdminGrowthInvestmentCategoryTypeString = function (): string {
    const value = this.valueOf() as EAdminGrowthInvestmentCategoryType

    switch (value) {
      case EAdminGrowthInvestmentCategoryType.OnlineAds:
        return "Anúncios online"

      case EAdminGrowthInvestmentCategoryType.PhysicalCampaign:
        return "Campanha física"

      case EAdminGrowthInvestmentCategoryType.People:
        return "Equipe e prestadores"

      case EAdminGrowthInvestmentCategoryType.InfluencerOrPartner:
        return "Influenciador ou parceria"

      case EAdminGrowthInvestmentCategoryType.Tooling:
        return "Ferramentas"

      case EAdminGrowthInvestmentCategoryType.Infrastructure:
        return "Infraestrutura"

      case EAdminGrowthInvestmentCategoryType.Event:
        return "Evento"

      case EAdminGrowthInvestmentCategoryType.Retention:
        return "Retenção"

      case EAdminGrowthInvestmentCategoryType.Other:
        return "Outro"

      default:
        return "Não definida"
    }
  }
}

if (!Number.prototype.toECommercialOriginTypeString) {
  Number.prototype.toECommercialOriginTypeString = function (): string {
    const value = this.valueOf() as ECommercialOriginType

    switch (value) {
      case ECommercialOriginType.Organic:
        return "Orgânica / Internet"

      case ECommercialOriginType.Reseller:
        return "Revendedor"

      case ECommercialOriginType.Campaign:
        return "Campanha"

      case ECommercialOriginType.Google:
        return "Google"

      case ECommercialOriginType.Facebook:
        return "Facebook"

      case ECommercialOriginType.Instagram:
        return "Instagram"

      case ECommercialOriginType.TikTok:
        return "TikTok"

      case ECommercialOriginType.YouTube:
        return "YouTube"

      case ECommercialOriginType.WhatsApp:
        return "WhatsApp"

      case ECommercialOriginType.Telegram:
        return "Telegram"

      case ECommercialOriginType.LinkedIn:
        return "LinkedIn"

      case ECommercialOriginType.Referral:
        return "Indicação de cliente"

      case ECommercialOriginType.Marketplace:
        return "Marketplace"

      case ECommercialOriginType.EmailMarketing:
        return "Email marketing"

      case ECommercialOriginType.Other:
        return "Outra origem"

      default:
        return "Não definida"
    }
  }
}

if (!Number.prototype.toCourierStatusTypeString) {
  Number.prototype.toCourierStatusTypeString = function (): string {
    const value = this.valueOf() as ECourierStatusType

    switch (value) {
      case ECourierStatusType.Offline:
        return "Offline"

      case ECourierStatusType.Online:
        return "Online"

      default:
        return "Offline"
    }
  }
}

if (!Number.prototype.toERestaurantServiceTypeString) {
  Number.prototype.toERestaurantServiceTypeString = function (): string {
    const value = this.valueOf() as ERestaurantServiceType

    switch (value) {
      case ERestaurantServiceType.Delivery:
        return "Delivery"

      case ERestaurantServiceType.Local:
        return "Local"

      case ERestaurantServiceType.Both:
        return "Delivery e Local"

      default:
        return "Delivery"
    }
  }
}

if (!Number.prototype.toEAccountPlansTypeToString) {
  Number.prototype.toEAccountPlansTypeToString = function (): string {
    const value = this.valueOf() as EAccountPlansType

    switch (value) {
      case EAccountPlansType.None:
        return "Grátis"

      case EAccountPlansType.Basic:
        return "Basic"

      case EAccountPlansType.Standard:
        return "Standard"

      case EAccountPlansType.Pro:
        return "Pro"

      case EAccountPlansType.Premium:
        return "Premium"

      case EAccountPlansType.Enterprise:
        return "Enterprise"

      case EAccountPlansType.Scale:
        return "Scale"

      default:
        return "Grátis"
    }
  }
}

if (!Number.prototype.toEBillingPeriodTypeToString) {
  Number.prototype.toEBillingPeriodTypeToString = function (): string {
    const value = this.valueOf() as EBillingPeriodType

    switch (value) {
      case EBillingPeriodType.Monthly:
        return "Mensal"

      case EBillingPeriodType.Quarterly:
        return "Trimestral"

      case EBillingPeriodType.Annual:
        return "Anual"

      default:
        return "Mensal"
    }
  }
}

if (!Number.prototype.toEPlanCouponDiscountTypeToString) {
  Number.prototype.toEPlanCouponDiscountTypeToString = function (): string {
    const value = this.valueOf() as EPlanCouponDiscountType

    switch (value) {
      case EPlanCouponDiscountType.Percentage:
        return "Percentual"

      case EPlanCouponDiscountType.FixedAmount:
        return "Valor fixo"

      default:
        return "Percentual"
    }
  }
}

if (!Number.prototype.toCourierVehicleTypeString) {
  Number.prototype.toCourierVehicleTypeString = function (): string {
    const value = this.valueOf() as ECourierVehicleType

    switch (value) {
      case ECourierVehicleType.MotorCycle:
        return "Moto"

      case ECourierVehicleType.Bike:
        return "Bicicleta"

      case ECourierVehicleType.Car:
        return "Carro"

      case ECourierVehicleType.Others:
        return "Outros"

      default:
        return "Moto"
    }
  }
}

if (!Number.prototype.toDeliveryStatusTypeString) {
  Number.prototype.toDeliveryStatusTypeString = function (): string {
    const value = this.valueOf() as EDeliveryStatusType

    switch (value) {
      case EDeliveryStatusType.Pending:
        return "Aguardando entregador"

      case EDeliveryStatusType.Offered:
        return "Oferecida"

      case EDeliveryStatusType.Accepted:
        return "Aceita"

      case EDeliveryStatusType.PickedUp:
        return "Pedido coletado"

      case EDeliveryStatusType.OnRoute:
        return "A caminho"

      case EDeliveryStatusType.Delivered:
        return "Entregue"

      case EDeliveryStatusType.Rejected:
        return "Rejeitada"

      case EDeliveryStatusType.Expired:
        return "Expirada"

      case EDeliveryStatusType.Canceled:
        return "Cancelada"

      default:
        return "Aguardando entregador"
    }
  }
}

export type LanguageOption = {
  label: string
  value: string
}

if (!Number.prototype.toLanguageType) {
  Number.prototype.toLanguageType = function (): LanguageOption {
    const value = this.valueOf() as ELanguagens

    switch (value) {
      case ELanguagens.PortugueseBr:
        return { label: "Português (BR)", value: "br" }

      /*case ELanguagens.PortuguesePt:
        return { label: "Português (PT)", value: "pt" }

      case ELanguagens.English:
        return { label: "English", value: "en" }

      case ELanguagens.Spanish:
        return { label: "Español", value: "es" }*/

      default:
        return { label: "Português (BR)", value: "br" }
    }
  }
}

if (!Number.prototype.toOrderPlaceTypeString) {
  Number.prototype.toOrderPlaceTypeString = function (): string {
    const value = this.valueOf() as EOrderPlaceType
    switch (value) {
      case EOrderPlaceType.Local:
        return "Local"
      case EOrderPlaceType.Delivery:
        return "Delivery"
      default:
        return "Local"
    }
  }
}

if (!Number.prototype.toEOrderTypeString) {
  Number.prototype.toEOrderTypeString = function (): string {
    const value = this.valueOf() as EOrderType
    switch (value) {
      case EOrderType.Open:
        return "Devendo"
      case EOrderType.Finished:
        return "Finalizado"
      case EOrderType.Canceled:
        return "Cancelado"
      default:
        return "Devendo"
    }
  }
}

if (!Number.prototype.toOrderCurrentStatusString) {
  Number.prototype.toOrderCurrentStatusString = function (): string {
    const value = this.valueOf() as EOrderCurrentStatus
    switch (value) {
      case EOrderCurrentStatus.Pending:
        return "Pendente"
      case EOrderCurrentStatus.Preparing:
        return "Em Produção"
      case EOrderCurrentStatus.Finished:
        return "Finalizado"
      case EOrderCurrentStatus.Closed:
        return "Entregue"
      default:
        return "Crescente"
    }
  }
}

if (!Number.prototype.toPaymentTypeString) {
  Number.prototype.toPaymentTypeString = function (): string {
    const value = this.valueOf() as EPaymentType
    switch (value) {
      case EPaymentType.None:
        return i18next.t("order:label_payment_none")
      case EPaymentType.Pix:
        return i18next.t("order:label_payment_pix")
      case EPaymentType.Cash:
        return i18next.t("order:label_payment_cash")
      case EPaymentType.Card:
        return i18next.t("order:label_payment_card")
      case EPaymentType.CreditCard:
        return i18next.t("order:label_payment_credit_card")
      case EPaymentType.DebitCard:
        return i18next.t("order:label_payment_debit_card")
      case EPaymentType.Other:
        return i18next.t("order:label_payment_other")
      case EPaymentType.FoodVoucher:
        return i18next.t("order:label_payment_food_voucher")
      case EPaymentType.MealVoucher:
        return i18next.t("order:label_payment_meal_voucher")
      case EPaymentType.TapToPay:
        return i18next.t("order:label_payment_tap_to_pay")
      default:
        return i18next.t("order:label_payment_none")
    }
  }
}

if (!Number.prototype.toOrderPaymentProviderTypeString) {
  Number.prototype.toOrderPaymentProviderTypeString = function (): string {
    const value = this.valueOf() as EOrderPaymentProviderType
    switch (value) {
      case EOrderPaymentProviderType.MercadoPago:
        return i18next.t("order:label_provider_mercado_pago")
      default:
        return i18next.t("order:label_provider_unknown")
    }
  }
}

if (!Number.prototype.toOrderType) {
  Number.prototype.toOrderType = function (): string {
    const value = this.valueOf() as EOrdenationType
    switch (value) {
      case EOrdenationType.Crescent:
        return "Crescente"
      case EOrdenationType.Decreasing:
        return "Decrescente"
      default:
        return "Crescente"
    }
  }
}

if (!Number.prototype.toSexTypeString) {
  Number.prototype.toSexTypeString = function (): string {
    const value = this.valueOf() as ESexType
    switch (value) {
      case ESexType.Woman:
        return "Mulher"
      case ESexType.Man:
        return "Homem"
      default:
        return "Homem"
    }
  }
}

if (!Number.prototype.toOldTypeString) {
  Number.prototype.toOldTypeString = function (): string {
    const value = this.valueOf() as EOldType
    switch (value) {
      case EOldType.IsChildren:
        return "É criança"
      case EOldType.IsAdult:
        return "Adulto"
      default:
        return "Adulto"
    }
  }
}

if (!Number.prototype.toCustomerPaymentTypeString) {
  Number.prototype.toCustomerPaymentTypeString = function (): string {
    const value = this.valueOf() as ECustomerPaymentType
    switch (value) {
      case ECustomerPaymentType.WithOutDebit:
        return "Quitado"
      case ECustomerPaymentType.WithInDebit:
        return "Devendo"
      case ECustomerPaymentType.All:
        return "Todos"
      default:
        return "Todos"
    }
  }
}

if (!Number.prototype.toGenderTypeString) {
  Number.prototype.toGenderTypeString = function (): string {
    const value = this.valueOf() as EGenderType
    switch (value) {
      case EGenderType.Woman:
        return "Mulheres"
      case EGenderType.Man:
        return "Homens"
      case EGenderType.Children:
        return "Crianças"
      case EGenderType.WomanAndMan:
        return "Mulheres e Homens"
      case EGenderType.WomanAndChildren:
        return "Mulheres e Crianças"
      case EGenderType.ManAndChildren:
        return "Homens e Crianças"
      case EGenderType.All:
        return "Todos"
      default:
        return "Todos"
    }
  }
}

if (!Number.prototype.toAutoTypeString) {
  Number.prototype.toAutoTypeString = function (): string {
    const value = this.valueOf() as EAutoType
    switch (value) {
      case EAutoType.Auto:
        return "Automático"
      case EAutoType.NotAuto:
        return "Não é automático"
      default:
        return "Desconhecido"
    }
  }
}

if (!Number.prototype.toTypeOfChangeString) {
  Number.prototype.toTypeOfChangeString = function (): string {
    const value = this.valueOf() as ETypeOfCharge
    switch (value) {
      case ETypeOfCharge.Weight:
        return "Por peso"
      case ETypeOfCharge.FixedValue:
        return "Valor fixo"
      default:
        return "Desconhecido"
    }
  }
}

if (!Number.prototype.toEnableStatusTypeString) {
  Number.prototype.toEnableStatusTypeString = function (): string {
    const value = this.valueOf() as EEnableStatusType
    switch (value) {
      case EEnableStatusType.Active:
        return "Ativo"
      case EEnableStatusType.Inactive:
        return "Inativo"
      case EEnableStatusType.All:
        return "Todos"
      default:
        return "Todos"
    }
  }
}

if (!Number.prototype.toMoneyConditionTypeString) {
  Number.prototype.toMoneyConditionTypeString = function (): string {
    const value = this.valueOf() as EMoneyConditionType
    switch (value) {
      case EMoneyConditionType.FixedValue:
        return "Valor Fixo"
      case EMoneyConditionType.Percentage:
        return "Porcentagem"
      default:
        return "Desconhecido"
    }
  }
}
